import React from "react";
import Bundles from "src/pages/callrecorder/Bundles";
import ShowBundle from "src/pages/callrecorder/Bundles/Show";
import PhnSubscriptionPlans from "src/pages/callrecorder/PhnSubscriptionPlans";
import SmsPackages from "src/pages/callrecorder/SmsPackages";
import Providers from "src/pages/callrecorder/Providers";
import CsvImports from "src/pages/callrecorder/CsvImports";
import ShowCsvImport from "src/pages/callrecorder/CsvImports/Show";
import AvailablePhoneNumbers from "src/pages/callrecorder/AvailablePhoneNumbers";
import PhoneNumberPrices from "src/pages/callrecorder/PhoneNumberPrices";
import ShowPhoneNumberPrice from "src/pages/callrecorder/PhoneNumberPrices/Show";
import Users from "src/pages/callrecorder/Users";
import ShowUser from "src/pages/callrecorder/Users/Show";
import ShowDevice from "src/pages/callrecorder/Devices/Show";
import ShowUserNumber from "src/pages/callrecorder/UserNumbers/Show";
import UserNumberSubscriptions from "src/pages/callrecorder/UserNumberSubscriptions";
import Rates from "src/pages/callrecorder/Rates";
import ShowRate from "src/pages/callrecorder/Rates/Show";
import Cdrs from "src/pages/callrecorder/Cdrs";
import ShowCdr from "src/pages/callrecorder/Cdrs/Show";

const callrecorderRoutes = [
  { path: '/callrecorder/bundles',                       element: <Bundles /> },
  { path: '/callrecorder/bundles/:id',                   element: <ShowBundle /> },
  { path: '/callrecorder/phn_subscription_plans',        element: <PhnSubscriptionPlans /> },
  { path: '/callrecorder/sms_packages',                  element: <SmsPackages /> },
  { path: '/callrecorder/providers',                     element: <Providers /> },
  { path: '/callrecorder/csv_imports',                   element: <CsvImports /> },
  { path: '/callrecorder/csv_imports/:id',               element: <ShowCsvImport /> },
  { path: '/callrecorder/available_phone_numbers',       element: <AvailablePhoneNumbers /> },
  { path: '/callrecorder/phone_number_prices',           element: <PhoneNumberPrices /> },
  { path: '/callrecorder/phone_number_prices/:id',      element: <ShowPhoneNumberPrice /> },
  { path: '/callrecorder/users',                        element: <Users /> },
  { path: '/callrecorder/users/:id',                    element: <ShowUser /> },
  { path: '/callrecorder/devices/:id',                  element: <ShowDevice /> },
  { path: '/callrecorder/user_numbers/:id',             element: <ShowUserNumber /> },
  { path: '/callrecorder/user_number_subscriptions',   element: <UserNumberSubscriptions /> },
  { path: '/callrecorder/rates',                       element: <Rates /> },
  { path: '/callrecorder/rates/:id',                   element: <ShowRate /> },
  { path: '/callrecorder/cdrs',                        element: <Cdrs /> },
  { path: '/callrecorder/cdrs/:id',                    element: <ShowCdr /> },
]

export default callrecorderRoutes;
